import axios from "../_helpers/axiosInstance.js";
import {authHeader} from "../_helpers/authHeader.js";

const login = async (username, password) => {
    const data = {  username, password };
    let response = await axios.post('auth/login', data);
    return response.data.result;
}
const refreshToken = async (jwtToken, refreshToken) => {
    const data = {jwtToken, refreshToken};
    let response = await axios.post('auth/refresh', data);
    return response.data.result;
}

const getExternalSession = async (sessionId) => {
    const response = await axios.get(`auth/external/session/${sessionId}`);
    return response.data.result;
}

const getLtsaStartUrl = () => {
    const rawBase = (import.meta.env.VITE_API_URL || "").replace(/\/+$/, "");
    const returnUrl = encodeURIComponent(window.location.origin + "/login");
    return `${rawBase}/auth/external/ltsa/start?returnUrl=${returnUrl}`;
}

const resetPassword = async (password, resetKey) => {
    const data = {password, resetKey};
    await axios.post(`auth/password/reset`, data);
}

const sendPasswordResetLink = async (emailAddress) => {
    const data = {emailAddress};
    await axios.post(`auth/password/resetLink`, data);
}

const validateResetKey = async (resetKey) => {
    const response = await axios.get(`auth/password/reset/${resetKey}/validate`, );
    return response.data.result;
}

const acceptInvite = async (activationKey, password) => {
    await axios.post(`useraccount/invite/${activationKey}`, {password});
};

const masquerade = async (userId) => {
    const response = await axios.post(`auth/masquerade`, {userId}, {headers: authHeader()});
    return response.data.result;
}

export const authApi = {
    login,
    refreshToken,
    getExternalSession,
    getLtsaStartUrl,
    resetPassword,
    sendPasswordResetLink,
    validateResetKey,
    acceptInvite,
    masquerade
}
